import SandboxNetsCertificationLayout from '../../views/journey/sandbox_nets_coursework_layout.jsx'

const SandboxNetsCertificationPage = () => {
  return (
      <SandboxNetsCertificationLayout />
  );
};

export default SandboxNetsCertificationPage;